module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "appear": _vm.appear,
      "mode": _vm.mode,
      "name": _vm.name,
      "css": false
    },
    on: {
      "beforeAppear": _vm.beforeAppear,
      "appear": _vm.appear_,
      "beforeEnter": _vm.beforeEnter,
      "enter": _vm.enter,
      "beforeLeave": _vm.beforeLeave,
      "leave": _vm.leave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46a53c22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/wrappers/transition-wrapper.vue
// module id = 482
// module chunks = 0